import $ from 'jquery';
import config from './config';
import { bustersConfig } from './constants/api-url';
import { filter, map, isEmpty } from 'lodash';

window.serverDate = new Date();
const common = {};
common.isFilledObj = (arg) => {
    return arg !== null && typeof arg === 'object' && !!Object.keys(arg).length;
};
common.isNotUndefined = (val) => {
    return typeof val !== 'undefined';
};
common.isBetween = (value, min, max) => {
    return value >= min && value <= max;
};
common.isMobile = () => {
    if (window.innerWidth > 768) {
        return false
    }
    return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
common.NO_OP = function () {
};
common.shuffle = (array) => {
    let currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
};
common.customTracking = (label, pageName, eventsrc) => {
    const params = { "event_src": eventsrc || config.APP_NAME, "event_name": "Click", "event_details": label, "pageName": pageName || window.location.pathname };
    try {
        window.dataLayer = window.dataLayer || [];
        if (params) {
            window.dataLayer.push({
                event: 'gaEvent',
                eventCategory: params.event_name,
                eventAction: params.event_details,
                eventLabel: params.event_src,
            });
        }
        if (window['utag']) {
            window['utag'].link(params)
        }
    } catch (e) {
    }
};


const getTrackingObject = (trackObj, path) => {


    let lang = config.CURRENT_LANGUAGE.toUpperCase();
    let profile = window.uefaGHComponent.getUserProfile();
    let env = config.readablePath;

    const oldKeys = ["event", "contentSection1", "contentSection2", "contentSection3", "pageSubType", "pageTitle", "pageType", "pageName", "pageFormat"];
    const newKeys = ["event", "contentSection1", "contentSection2", "contentSection3", "pageSubType", "pageTitle", "pageType", "pageName", "pageFormat"];
    var obj = {}


    if (trackObj.type == "new") {
        newKeys.map(function (key) {
            obj[key] = trackObj[key]
        })
    } else {
        obj = {
            event: trackObj.TrkEvent || 'Page Meta',
            contentSection1: 'gaminghub',
            contentSection2: config.APP_NAME,
            contentSection3: trackObj.name || trackObj.TrkName,
            pageSubType: trackObj.TrkPageSubType,
            pageTitle: trackObj.TrkPageTitle || trackObj.TrkName,
            pageType: trackObj.TrkPageType,
            pageName: path || trackObj.TrkPageName,
            pageFormat: trackObj.TrkPageFormat,
        }
    }


    var constantKeys = {
        partners: 'playstation',
        environment: env,
        language: lang,
        pageLanguage: lang,
        country: (profile && profile['ref_country_code']) ? profile['ref_country_code'] : undefined,
        userID: (profile && profile['anonymous']) ? undefined : profile.id,
        userLoginStatus: (profile && profile['anonymous']) ? 'false' : 'true'
    }

    return { ...obj, ...constantKeys }
};
common.pageViewTracking = (page, routeObject) => {
    let path = '/' + config.APP_NAME + page;
    if (path.lastIndexOf('/') !== path.length - 1) path += '/';
    try {
        window.dataLayer = window.dataLayer || [];
        if (routeObject.TrkPageSubType == "landing" && routeObject.type != "new") {
            return
        }

        const trackObj = getTrackingObject(routeObject, path);
        window.dataLayer.push(trackObj);
        // if (!window.initialLoaded) {
        //     const trackVirPathObj = { ...trackObj, event: 'virtPath', virtPath: trackObj.pageName };
        //     window.dataLayer.push(trackVirPathObj);
        // }
        window.initialLoaded = false;
    } catch (e) {
    }
};
common.virPathTracking = (page) => {
    let entityObject = config.trackclickEvents[page] || null;
    try {
        if (entityObject) {
            window.dataLayer = window.dataLayer || [];
            const trackObj = getTrackingObject(entityObject);
            window.dataLayer.push({ ...trackObj, virtPath: trackObj.pageName });
        }
    } catch (e) {

    }
};
common.adTracking = (eventType, promotions = []) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': eventType || 'Sponsor View',
        'ecommerce': {
            'promoView': {
                promotions
            }
        }
    });
};
common.adClickTracking = (eventType, promotions = []) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': eventType || 'Sponsor Click',
        'ecommerce': {
            'promoClick': {
                promotions
            }
        }
    });
};
common.setCookie = (c_name, value, exDays = null) => {
    let exDate = new Date();
    exDate.setDate(exDate.getDate() + exDays);
    let c_value = (value) + ((exDays === null) ? "" : "; expires=" + exDate.toUTCString());
    document.cookie = c_name + "=" + c_value;
};
common.getCookie = (c_name) => {
    let i, x, y, cookiesArray = document.cookie.split(";");
    for (i = 0; i < cookiesArray.length; i++) {
        x = cookiesArray[i].substr(0, cookiesArray[i].indexOf("="));
        y = cookiesArray[i].substr(cookiesArray[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x === c_name) {
            return (y);
        }
    }
};
common.deleteCookie = (name) => {
    document.cookie = `${name}=; Path=/;domain=.uefa.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
common.removeBodyScroll = () => {
    const bodyElem = document.body;
    bodyElem.classList.remove('bodyNoScroll');
};
common.addBodyScroll = () => {
    const bodyElem = document.body;
    bodyElem.classList.add('bodyNoScroll');
};
common.parseCookie = (cookie) => {
    try {
        return JSON.parse(decodeURIComponent(cookie));
    } catch (e) {

    }
};
common.getGUID = () => {
    let COOKIE_GM = config.COOKIE_GM;
    let parsedCookieGM = null;
    let GUID = null;
    let cookieGM = common.getCookie(COOKIE_GM);
    if (cookieGM) {
        parsedCookieGM = common.parseCookie(cookieGM);
        if (parsedCookieGM) {
            GUID = parsedCookieGM['GUID'];
        }
    }
    return GUID;
};
common.getTeamName = () => {
    let COOKIE_GM = config.COOKIE_GM;
    let parsedCookieGM = null;
    let teamName = null;
    let cookieGM = common.getCookie(COOKIE_GM);
    if (cookieGM) {
        parsedCookieGM = common.parseCookie(cookieGM);
    }
    if (parsedCookieGM && parsedCookieGM['TeamName']) {
        teamName = decodeURIComponent(parsedCookieGM['TeamName']);
    }
    return teamName;
};
common.getDataFromCookie = (key) => {
    let COOKIE_GM = config.COOKIE_GM;
    let parsedCookieGM = null;
    let value = null;
    let cookieGM = common.getCookie(COOKIE_GM);
    if (cookieGM) {
        parsedCookieGM = common.parseCookie(cookieGM);
    }
    if (parsedCookieGM && parsedCookieGM[key]) {
        value = decodeURIComponent(parsedCookieGM[key]);
    }
    return value;
};
common.isManageTeam = () => {
    let COOKIE_GM = config.COOKIE_GM;
    let parsedCookieGM = null;
    let isManageTeam = false;
    let cookieGM = common.getCookie(COOKIE_GM);
    if (cookieGM) {
        parsedCookieGM = common.parseCookie(cookieGM);
    }
    if (parsedCookieGM && (+parsedCookieGM['HasTeam'] === config.teamStatus.hasTeam)) {
        isManageTeam = true;
    }
    return isManageTeam;
};
common.validateInput = (value) => {
    /* eslint-disable */
    return value.replace(/["'\/\\<>|;]/gi, '');
    /* eslint-enable */
};
common.getLocalStorage = (key) => {
    const localData = localStorage.getItem(key);
    try {
        return JSON.parse(localData);
    } catch (e) {

        return false;
    }
};
common.setLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
};
common.removeLocalStorage = (key) => {
    localStorage.removeItem(key);
};
common.makeClasses = (obj = {}) => {
    return Object.keys(obj).filter(key => obj[key]).join(' ');
};
common.makeQueryString = (data, url, isJson) => {

    if (data.language) {
        data["languageCode"] = data.language
    }
    if (isJson) {
        var queryNew = "";
        Object.keys(data).forEach(function (item) {
            queryNew = url.replace("{" + item + "}", data[item]);
            url = queryNew;

        });
        if (data.buster) {
            queryNew = queryNew + "?buster=" + data.buster
        }
        return queryNew;
    } else {
        var query = "";
        query = Object.keys(data)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(data[k]))
            .join('&');
        return query ? ('?' + query) : '';
    }



};

const getBusterStr = () => {
    return Math.random().toString(36).substr(2, 9) + Date.now();
};
common.updateBusters = (postAPI) => {
    for (let j = 0; j < bustersConfig[postAPI].length; j++) {
        const getAPI = bustersConfig[postAPI][j];
        localStorage.setItem(`_buster_${getAPI}`, getBusterStr());
    }
};
((busters) => {
    Object.keys(busters).forEach(postAPI => {
        busters[postAPI].forEach(getAPI => {
            const valueSetInLocalStorage = localStorage.getItem(`_buster_${getAPI}`);
            if (!valueSetInLocalStorage) {
                localStorage.setItem(`_buster_${getAPI}`, getBusterStr());
            }
        });
    });
})(bustersConfig);
const isWordLastInString = (str, word) => {
    const index = str.lastIndexOf(word);
    return (index > -1 && index === (str.length - word.length));
    // return true;
};
common.makeAPICall = (endPoint, dispatch, loadingStateAction, successAction, failedAction, data = {}, type = 'GET') => {
    let buster = '';
    if (type === 'GET') {
        const keys = Object.keys(bustersConfig);
        parent: for (let i = 0; i < keys.length; i++) {
            const postAPI = keys[i];
            for (let j = 0; j < bustersConfig[postAPI].length; j++) {
                const getAPI = bustersConfig[postAPI][j];
                if (isWordLastInString(endPoint, getAPI)) {
                    buster = localStorage.getItem(`_buster_${getAPI}`);
                    break parent;
                }
            }
        }
    }
    const isJSON = endPoint.indexOf('.json') > -1;
    const apiObj = {
        method: type
    };
    if (!isJSON) {
        apiObj.headers = config.headers;
        apiObj.credentials = 'include';
    }
    if (type === 'GET') {
        buster && (data.buster = buster);
        if (isJSON) {
            var TourId = { "TourId": config.TourId };
            endPoint = common.makeQueryString({ ...data, ...TourId }, endPoint, isJSON);
        } else {
            // endPoint += common.makeQueryString(data);
            endPoint += common.makeQueryString(data, endPoint, isJSON);
        }

    } else {
        apiObj.body = JSON.stringify(data);
    }
    dispatch(loadingStateAction(true));
    return window['fetch'](endPoint, apiObj)
        .then((response) => {
            window.serverDate = response.headers.get('Date');
            for (let entry of response.headers.entries()) {
                entry.map(function (obj) {
                    if (obj[0] == "date") {
                        window.serverDate = obj[1]
                    }
                })
            }
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((res) => res.json())
        .then((data) => {
            dispatch(loadingStateAction(false));
            if (data.Meta['Success']) {
                if (type === 'POST') {
                    const keys = Object.keys(bustersConfig);
                    for (let i = 0; i < keys.length; i++) {
                        const postAPI = keys[i];
                        if (endPoint.indexOf(postAPI) > -1) {
                            common.updateBusters(postAPI);
                            break;
                        }
                    }
                }
            }
            if (data.Meta['Success'] && data.Meta['RetVal'] === 1) {
                if (data.Data.Value.UCL2018_FAN) {
                    var cookie = encodeURIComponent(JSON.stringify(data.Data.Value.UCL2018_FAN));
                    var exdays = 1000;
                    var d = new Date();
                    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                    var expires = "expires=" + d.toUTCString();
                    document.cookie = "UCL_CLASSIC_RAW=" + cookie + "; " + expires + "; path=/; domain=.uefa.com";
                }
                return dispatch(successAction(data, dispatch));
            } else {
                if (data.Meta['RetVal'] === 2020) {
                    //delete cookies and ridirect to gaming hum
                    common.deleteCookie(config.AUTH_COOKIE);
                    common.deleteCookie(config.COOKIE_GM);
                    common.removeLocalStorage('totalScore');
                    common.removeLocalStorage('profile');
                    setTimeout(function () {
                        window.location.href = config.BASE_DOMAIN;
                    }, 500)
                } else {
                    dispatch(successAction(data));
                    return dispatch(failedAction(true));
                }

            }
        })
        .catch((e) => {
            dispatch(loadingStateAction(false));
            return dispatch(failedAction(true))
        });
};

common.callBackApiCall = (endPoint, callbackSuccess, callbackError, data = {}, type = 'GET') => {
    let buster = '';
    if (type === 'GET') {
        const keys = Object.keys(bustersConfig);
        parent: for (let i = 0; i < keys.length; i++) {
            const postAPI = keys[i];
            for (let j = 0; j < bustersConfig[postAPI].length; j++) {
                const getAPI = bustersConfig[postAPI][j];
                if (isWordLastInString(endPoint, getAPI)) {
                    buster = localStorage.getItem(`_buster_${getAPI}`);
                    break parent;
                }
            }
        }
    }
    const isJSON = endPoint.indexOf('.json') > -1;
    const apiObj = {
        method: type
    };
    if (!isJSON) {
        apiObj.headers = config.headers;
        apiObj.credentials = 'include';
    }
    if (type === 'GET') {
        buster && (data.buster = buster);
        if (isJSON) {
            var TourId = { "TourId": config.TourId };
            endPoint = common.makeQueryString({ ...data, ...TourId }, endPoint, isJSON);
        } else {
            // endPoint += common.makeQueryString(data);
            endPoint += common.makeQueryString(data, endPoint, isJSON);
        }

    } else {
        apiObj.body = JSON.stringify(data);
    }
    //show loader
    common.showLoader();
    return window['fetch'](endPoint, apiObj)
        .then((response) => {
            window.serverDate = response.headers.get('Date');
            for (let entry of response.headers.entries()) {
                entry.map(function (obj) {
                    if (obj[0] == "date") {
                        window.serverDate = obj[1]
                    }
                })
            }
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then((res) => res.json())
        .then((data) => {
            common.hideLoader();
            if (data.Meta['Success']) {
                if (type === 'POST') {
                    const keys = Object.keys(bustersConfig);
                    for (let i = 0; i < keys.length; i++) {
                        const postAPI = keys[i];
                        if (endPoint.indexOf(postAPI) > -1) {
                            common.updateBusters(postAPI);
                            break;
                        }
                    }
                }
            }
            if (data.Meta['Success'] && data.Meta['RetVal'] === 1) {
                if (data.Data.Value.UCL2018_FAN) {
                    var cookie = encodeURIComponent(JSON.stringify(data.Data.Value.UCL2018_FAN));
                    var exdays = 1000;
                    var d = new Date();
                    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                    var expires = "expires=" + d.toUTCString();
                    document.cookie = "UCL_CLASSIC_RAW=" + cookie + "; " + expires + "; path=/; domain=.uefa.com";
                }

                callbackSuccess(data.Data.Value || []);
            } else {
                var noPlayers = [];
                callbackError(noPlayers);
            }
        })
        .catch((e) => {
            common.hideLoader();
            var noPlayers = [];
            callbackError(noPlayers);
        });
}

common.numToWord = (num) => {
    const a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    return a[num];
};
common.showLoader = () => {
    $('#loader').fadeIn(100);
};
common.hideLoader = () => {
    $('#loader').fadeOut(100);
};
common.scrollToElement = (jQElem, factorToAdd = 0, duration = 500, parentSelector = 'html, body') => {
    try {
        const topValue = $(jQElem).offset().top - factorToAdd;
        $(parentSelector).animate({
            scrollTop: topValue
        }, duration);
    } catch (e) {

    }
};
common.isElementInViewport = (el) => {
    if (el) {
        let top = el.offsetTop;
        let left = el.offsetLeft;
        let width = el.offsetWidth;
        let height = el.offsetHeight;
        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }
        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }
};
Date.daysBetween = function (date1, date2) {
    //Get 1 day in milliseconds
    // Convert both dates to milliseconds
    let date1_ms = date1.getTime();
    let date2_ms = date2.getTime();
    // Calculate the difference in milliseconds
    let difference_ms = date2_ms - date1_ms;
    let ms_Diff = difference_ms;
    //take out milliseconds
    difference_ms = difference_ms / 1000;
    let seconds = Math.floor(difference_ms % 60);
    difference_ms = difference_ms / 60;
    let minutes = Math.floor(difference_ms % 60);
    difference_ms = difference_ms / 60;
    let hours = Math.floor(difference_ms % 24);
    let days = Math.floor(difference_ms / 24);
    //hours = hours + (days * 24);
    let jTotal = days + hours + minutes + seconds;
    let jTotalHours = /*(days * 24) +*/ hours;
    let hoursText = "hr" + (jTotalHours > 1 ? "s" : "");
    let minutesText = "min" + (minutes > 1 ? "s" : "");
    let daysText = "day" + (days > 1 ? "s" : "");
    if (minutes < 0) {
        minutes = 0;
    }
    return {
        ms_Diff: ms_Diff,
        jTotal: jTotal,
        days: days,
        hours: jTotalHours,
        minutes: minutes,
        daysText: daysText,
        hoursText: hoursText,
        minutesText: minutesText,
        seconds: seconds
    };
};
common.calculatePercentage = (jTargetTotal, jDifference, jPlusStartPosition, jPercentageBy) => {
    // let jTotal = maxTime;//1209599000;//14Days 23Hr 59Min 59Sec. 
    let jResp = jPercentageBy * (jDifference / jTargetTotal);
    return ((jResp + jPlusStartPosition));
};
/* eslint-disable */
common.dateFormat = function () {
    let d = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[ ^']*'/g,
        f = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
        c = /[^-+\dA-Z]/g, b = function (a, g) {
            for (a = String(a), g = g || 2; a.length < g;) {
                a = "0" + a
            }
            return a
        };
    return function (x, j, a) {
        let A = common.dateFormat;
        if (1 !== arguments.length || "[object String]" !== Object.prototype.toString.call(x) || /\d/.test(x) || (j = x, x = void 0), x = x ? new Date(x) : new Date, isNaN(x)) {
            throw SyntaxError("invalid date")
        }
        j = String(A.masks[j] || j || A.masks["default"]), "UTC:" === j.slice(0, 4) && (j = j.slice(4), a = !0);
        let C = a ? "getUTC" : "get", q = x[C + "Date"](), e = x[C + "Day"](), B = x[C + "Month"](),
            w = x[C + "FullYear"](), k = x[C + "Hours"](), m = x[C + "Minutes"](), t = x[C + "Seconds"](),
            z = x[C + "Milliseconds"](), v = a ? 0 : x.getTimezoneOffset(), p = {
                d: q,
                dd: b(q),
                ddd: A.i18n.dayNames[e],
                dddd: window.TRANS && window.TRANS[A.i18n.dayNames[e + 7]] ? window.TRANS[A.i18n.dayNames[e + 7]] : A.i18n.dayNames[e + 7],
                m: B + 1,
                mm: b(B + 1),
                mmm: A.i18n.monthNames[B],
                mmmm: window.TRANS && window.TRANS[A.i18n.monthNames[B + 12]] ? window.TRANS[A.i18n.monthNames[B + 12]] : A.i18n.monthNames[B + 12],
                yy: String(w).slice(2),
                yyyy: w,
                h: k % 12 || 12,
                hh: b(k % 12 || 12),
                H: k,
                HH: b(k),
                M: m,
                MM: b(m),
                s: t,
                ss: b(t),
                l: b(z, 3),
                L: b(z > 99 ? Math.round(z / 10) : z),
                t: 12 > k ? "a" : "p",
                tt: 12 > k ? "am" : "pm",
                T: 12 > k ? "A" : "P",
                TT: 12 > k ? "AM" : "PM",
                Z: a ? "UTC" : (String(x).match(f) || [""]).pop().replace(c, ""),
                o: (v > 0 ? "-" : "+") + b(100 * Math.floor(Math.abs(v) / 60) + Math.abs(v) % 60, 4),
                S: ["th", "st", "nd", "rd"][q % 10 > 3 ? 0 : (q % 100 - q % 10 !== 10) * q % 10]
            };
        return j.replace(d, function (g) {
            return g in p ? p[g] : g.slice(1, g.length - 1)
        })
    }
}();
common.dateFormat.masks = {
    "default": "ddd mmm dd yyyy HH:MM:ss",
    shortDate: "m/d/yy",
    mediumDate: "mmm d, yyyy",
    longDate: "mmmm d, yyyy",
    fullDate: "dddd, mmmm d, yyyy",
    shortTime: "h:MM TT",
    mediumTime: "h:MM:ss TT",
    longTime: "h:MM:ss TT Z",
    isoDate: "yyyy-mm-dd",
    isoTime: "HH:MM:ss",
    isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
}, common.dateFormat.i18n = {
    dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
        'sunday',//(window.TRANS && window.TRANS.sunday ? window.TRANS.sunday : 'Sunday'),
        'monday',//(window.TRANS && window.TRANS.monday ? window.TRANS.monday : 'Monday'),
        'tuesday',//(window.TRANS && window.TRANS.tuesday ? window.TRANS.tuesday : 'Tuesday'),
        'wednesday',//(window.TRANS && window.TRANS.wednesday ? window.TRANS.wednesday : 'Wednesday'),
        'thursday',//(window.TRANS && window.TRANS.thursday ? window.TRANS.thursday : 'Thursday'),
        'friday',//(window.TRANS && window.TRANS.friday ? window.TRANS.friday : 'Friday'),
        'saturday'],//(window.TRANS && window.TRANS.saturday ? window.TRANS.saturday : 'Saturday')],
    monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", 'june'/*(window.TRANS && window.TRANS.june ? window.TRANS.june : 'June')*/, 'july'/*(window.TRANS && window.TRANS.july ? window.TRANS.july : 'July')*/, "August", "September", "October", "November", "December"]
}, Date.prototype.format = function (a, b) {
    return common.dateFormat(this, a, b)
};
/* eslint-enable */
common.calcTime = function (sDate, offset = "+0") {  // create Date object for current location
    let d = new Date(sDate);  // convert to msec
    // add local time zone offset
    // get UTC time in msec
    let utc = d.getTime() + (d.getTimezoneOffset() * 60000);  // create new Date object for different city
    // using supplied offset
    let nd = new Date(utc + (3600000 * offset));  // return time as a string
    return nd.toISOString();
};

function diff_minutes(dt2, dt1) {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.round(diff);
}

common.getDiffWithCurrentTimeInMinutes = (Deadline, OffSet = "+2", cb) => {
    let deadlineDateTimeObj = new Date(Deadline);
    common.getServerDate(serverDate => {
        let serverDateObj = common.calcTime(serverDate, OffSet);
        serverDateObj = new Date(serverDateObj);
        const diffInMins = diff_minutes(deadlineDateTimeObj, serverDateObj);
        return cb(diffInMins);
    });
};
common.getIndexOfArrayByValue = function (arr, sKey, value) {
    for (let j = 0; j < arr.length; j++) {
        if (arr[j][sKey] === value) {
            return j;
        }
    }
    return -1;
};
common.CompConvertHexToString = function (shareLoad) {
    let hex = shareLoad.toString();//force conversion
    let str = '';
    for (let i = 0; i < hex.length; i += 2)
        str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    let leagueArr = ['v1', 'v2', 'v3', 'v4'];
    let new_tempArr = str.split('##');
    let temp = '';
    for (let j = 0; j < new_tempArr.length; j++) {
        temp += leagueArr[j] + '#=#' + new_tempArr[j];
        if (j < new_tempArr.length - 1)
            temp += '&=&';
    }
    let cookieObj = {};
    temp = temp.split('&=&');
    for (let i = 0, l = temp.length; i < l; i++) {
        let x = temp[i];
        let temp1 = x.split('#=#');
        let key = temp1[0];
        cookieObj[key] = temp1[1].replace(/\+/g, ' ');
    }
    return cookieObj;
};
common.getServerDate = (cb) => {
    const apiObj = {};
    apiObj.headers = { 'Access-Control-Expose-Headers': 'Date' };
    apiObj.method = 'HEAD';
    window.fetch('/en/uclfantasy/static/1by1.jpg', apiObj).then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return cb(response.headers.get('Date'));
    }).catch(function () {
        cb((new Date()).toUTCString());
    });
};
common.memberNotation = (count = 0) => {
    let notation = count.toString();
    if (count > 0 && count < 1000)
        notation = count.toString();
    if (count > 999 && count < 5000)
        notation = "1k+";
    if (count > 4999 && count < 10000)
        notation = "5k+";
    if (count > 9999 && count < 20000)
        notation = "10k+";
    if (count > 19999 && count < 30000)
        notation = "20k+";
    if (count > 29999 && count < 40000)
        notation = "30k+";
    if (count > 39999 && count < 50000)
        notation = "40k+";
    if (count > 49999 && count < 60000)
        notation = "50k+";
    if (count > 59999 && count < 70000)
        notation = "60k+";
    if (count > 69999 && count < 80000)
        notation = "70k+";
    if (count > 79999 && count < 90000)
        notation = "80k+";
    if (count > 89999 && count < 100000)
        notation = "90k+";
    if (count > 99999 && count < 200000)
        notation = "100k+";
    if (count > 199999 && count < 300000)
        notation = "200k+";
    if (count > 299999 && count < 400000)
        notation = "300k+";
    if (count > 399999 && count < 500000)
        notation = "400k+";
    if (count > 499999 && count < 600000)
        notation = "500k+";
    if (count > 599999 && count < 700000)
        notation = "600k+";
    if (count > 699999 && count < 800000)
        notation = "700k+";
    if (count > 799999 && count < 900000)
        notation = "800k+";
    if (count > 899999 && count < 1000000)
        notation = "900k+";
    if (count > 999999)
        notation = "1m+";
    return notation;
};

common.isEndOfSeason = function (TRCODE) {
    // TRCODE = "TR_POST"
    if (TRCODE) {
        return TRCODE == config.enumscinarioCode.postTournament ? true : false;
    } else {
        return false;
    }

}

common.hideVisibility = function () {
    return { "visibility": "hidden" }
}

common.disablePlayer = function (teamData, player, maxPlayerCount) {
    if (Array.isArray(teamData[0] ? teamData[0] : {})) {
        const orderToScan = ['4', '3', '2', '1', '0'];
        let showDisabled = true;
        //check max team condition
        const jMaxTeamCount = maxPlayerCount ? maxPlayerCount : 3;
        let totalCount = orderToScan.reduce((initialValue, position) => {
            initialValue += filter(teamData[position], (playerObj) => playerObj.id && +playerObj.details.TID === +player.TID).length;
            return initialValue;
        }, 0);
        if (totalCount >= jMaxTeamCount) {
            //also check if player in team
            for (var i = 0; i < orderToScan.length; i++) {
                for (var j = 0; j < teamData[i].length; j++) {
                    if (teamData[i][j].id == player.Id) {
                        return false;
                    }
                }
            }
            return true;

        }


        for (var i = 0; i < orderToScan.length; i++) {
            for (var j = 0; j < teamData[i].length; j++) {
                if (teamData[i][j].id == null && teamData[i][j].skill == player.Skill) {
                    showDisabled = false;
                }
                if (teamData[i][j].id == player.Id) {
                    showDisabled = false;
                }
            }
        }

        //check if player is in team

        return showDisabled;
    } else {
        return false
    }
}

common.getClientNameFromLandingURL = function () {
    let pathName = window.location.pathname
    let arr = pathName.split("/")
    let pName = arr[arr.length - 1]
    if (pName.indexOf('landing') >= 0) {
        let landingName = pName.split('-')
        let clientName = (landingName && landingName.length) ? landingName[0] : "fantasy"
        if (clientName.trim().length && (config.landingPageClients.findIndex((c) => { return (c == clientName) }) >= 0)) {
            return clientName;
        }
        return "fantasy";
    }
    return "fantasy";
}

common.setDropDownHeight = function (id, liHeight, liLength) {
    // get ul height
    var ulHeight = $(id).height() ? $(id).height() : 190;
    var calLiHeight = liHeight * liLength;
    if (ulHeight > calLiHeight) {
        return { "height": calLiHeight + "px" }
    } else {
        return {
            "height": ulHeight + "px"
        }
    }


}

common.setPriceFilterArrays = function (prizeArray, type) {
    var defaultObj = { id: 102, label: "Affordable", max: 105, min: 0 }
    if (type == 'priceFilter') {

        let arrayPrizeFilter = [];
        arrayPrizeFilter.push(defaultObj);
        for (var i = 0; i < prizeArray.length; i++) {
            var obj = { id: i == 0 ? 100 : i == 1 ? 101 : i, label: i == 0 || i == 1 ? prizeArray[i]["label"] : "€" + prizeArray[i]["label"], min: parseFloat(prizeArray[i]["min"]), max: prizeArray[i]["max"] }
            arrayPrizeFilter.push(obj);
        }
        return arrayPrizeFilter;
    } else {
        var obj = { 102: defaultObj };
        for (var i = 0; i < prizeArray.length; i++) {
            obj[i == 0 ? 100 : i == 1 ? 101 : i] = { id: i == 0 ? 100 : i == 1 ? 101 : i, label: i == 0 || i == 1 ? prizeArray[i]["label"] : "€" + prizeArray[i]["label"], min: prizeArray[i]["min"], max: prizeArray[i]["max"] }

        }
        return obj;
    }

}


common.cardImpression = (card, params) => {
    try {
        window.dataLayer = window.dataLayer || [];

        let GHComponent = window.uefaGHComponent,
            cardConstants = config.cardConstants

        let trackObj = {
            // environment: config.BASE_DOMAIN,
            event: 'Card Impression',
            ecommerce: {}

        }
        let eventPrams = cardConstants[card]

        if (eventPrams) {
            eventPrams.brand = 'ucl'
            eventPrams.list = 'hub-gaming'
            if (params && !isEmpty(params)) {
                eventPrams = { ...eventPrams, ...params };
            }
            trackObj.ecommerce.impressions = [eventPrams]
            window.dataLayer.push(trackObj)
        }
    } catch (e) {
    }
}

common.getPageName = (params) => {
    let pageName = "";
    if (window.location.pathname.indexOf("/manage-team")) {
        pageName = params == "create/manage" ? "/uclfantasy/my-team/manage/" : "/uclfantasy/my-team/transfers/"
    } else {
        pageName = "/uclfantasy/create-team/"
    }
    return pageName;
}

common.cestToLocalTime = (matchTime, OffSet) => {
    var date = new Date(matchTime);
    //CEST is 2 hrs (daylight saving--offset value) ahead of GMT hence substracted 2
    date = date.setHours(date.getHours() - OffSet); //Converted to GMT time
    date = new Date(date);
    var localOffset = new Date().getTimezoneOffset() * 60000;
    var localTime = date.getTime();
    date = localTime - localOffset;
    date = new Date(date);
    var hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
    var minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
    return hours + ':' + minutes
}

common.detectAdBlocker = (setState) => {

    const head = document.getElementsByTagName('head')[0];

    const noAdBlockDetected = () => {
        // alert("false not detected")
        setState(true, false)
        // common.setLocalStorage("isAdBlocked", false);
        // return false
    }
    const adBlockDetected = () => {
        // alert("true detected")
        setState(true, true)
        // common.setLocalStorage("isAdBlocked", true);
    }
    // clean up stale bait
    const oldScript =
        document.getElementById('adblock-detection');
    if (oldScript) {
        head.removeChild(oldScript);
    }
    // we will dynamically generate some 'bait'.
    const script = document.createElement('script');
    script.id = 'adblock-detection';
    script.type = 'text/javascript';
    script.src = 'https://adservice.google.co.in/adsid/integrator.js?domain=' + window.location.host;
    script.onload = noAdBlockDetected;
    script.onerror = adBlockDetected;
    head.appendChild(script);
}


export default common;


// WEBPACK FOOTER //
// ./src/common.js